import {
  type ErrorComponentProps,
  useRouter,
  useRouterState,
} from "@tanstack/react-router";

import { ErrorView } from "./ErrorView";

export function ErrorPage({ reset }: ErrorComponentProps) {
  const router = useRouter();
  // The shell is up while the /_authed layout itself did not fail: the error
  // came from a page inside it, so it stays in the main content.
  const inShell = useRouterState({
    select: (s) =>
      s.matches.some((m) => m.routeId === "/_authed" && m.status !== "error"),
  });

  return (
    <ErrorView
      inShell={inShell}
      onRetry={() => {
        router.invalidate();
        reset();
      }}
    />
  );
}
